import React from 'react'
import { PropTypes } from 'prop-types'
import { FullscreenLoading } from './FullscreenLoading'
import { PartialLoading } from './PartialLoading'

export const LOADING_TYPES = {
  Partial: 'partial',
  Fullscreen: 'fullscreen'
}

export function LoadingFactory(props) {
  switch (props.type) {
    case LOADING_TYPES.Partial:
      return <PartialLoading {...props} />
    case LOADING_TYPES.Fullscreen:
      return <FullscreenLoading {...props} />

    default:
      return <PartialLoading {...props} />
  }
}

LoadingFactory.propTypes = {
  type: PropTypes.string
}
